<template>
  <!-- 了解索道云主页 -->
  <div class="main">
    <channel-banner></channel-banner>
    <!-- 介绍 -->
    <el-row class="intro">
      <el-col :span="10">
        <img class="intro_picture" src="@/assets/channel/ljsdy/ropeway.png" alt="">
      </el-col>
      <el-col :span="10">
        <div class="intro_title">
          <div>索道云介绍</div> 
          <div class="">一</div>
        </div>
        <div class="intro_content">
          索道云的概念率先由索道科技发展有限公司提出道有限公司位于我国著名的旅风景陕西华山三特索道有限公司位于我国著名的旅游风景名胜区西岳华山东麓，
          由华阴华山公路索道总公司与武汉三的中其建设难度之大、投资规模之大、设备之精10日建成运营，索精10
          西岳华山东麓，由华阴华山公路索道总公司与武汉三特索道集团股份有限公司、新加坡高技术公司共同兴建的中外合作玛亚公司产品，为单线循环脱挂式6
          西岳华山东麓，由华阴华山公路索道总公司与武汉三特索道集团股份有限公司、新加坡高技术公司共同兴建的中外合作玛亚公司产品，为单线循环式6地利多贝玛亚公司最之精良被业
          保护系统，索道全长1524.9米，落差755米，并拥有国内唯一一条救护索道，华山三特索道以其建设难度之大、投资规模之大、设备之精
        </div>
      </el-col>
    </el-row>
    <!-- 客户案例 -->
    <div class="customer_case">
      <div class="case_title">
        <div>客户案例</div>
        <div>一</div>
      </div>
      <el-row class="case_con">
        <!-- 左侧按钮 -->
        <el-col :span="4" v-if="arrowVisibility">
          <div class="arrow">
            <i v-if="leftArrowVisibility" class="el-icon-arrow-left" @click="slipLeft"></i>
            <i v-if="rightArrowVisibility" class="el-icon-arrow-right" @click="slipRight"></i>
          </div>
        </el-col>
        <!-- 案例内容 -->
        <el-col :span="5" v-for="(item,index) in customerList" :key="index">
            <div class="single_case">
                <img v-if="item.image" :src="item.image" alt="">
                <div class="single_name">{{item.name}}</div>
                <div class="case_singlecon">{{item.content}}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 新闻动态 -->
    <div class="news">
      <div class="news_title">
        <div>新闻动态</div>
        <div>一</div>
      </div>
      <el-row class="news_con">
        <!-- 左侧按钮 -->
        <el-col :span="3">
          <div class="news_arrow">
            <i v-if="newsleftArrow" class="el-icon-arrow-left" @click="leftNews"></i>
          </div>
        </el-col>
        <!-- 新闻内容 -->
        <el-col :span="18">
          <!-- 第一种布局 -->
          <el-row v-if="oddNumber">
            <el-col :span="9">
                <!-- <div class="square" @click="seeNews(0)" :style="{'background-image':`url(${newsList[0].image})`}"> -->
                <div class="square" @click="seeNews(0)" v-if="newsList[0]">
                  <img class="square_img" :src="newsList[0].image" alt="">
                  <div class="mask"></div>
                  <div class="single_con">
                    <div class="single_title">{{newsList[0].title}}</div>
                    <div class="single_summary">{{newsList[0].summary}}</div>
                  </div>
                </div>
            </el-col>
            <el-col :span="15">
              <div class="rectangle">
                <!-- <div class="rec_top" @click="seeNews(1)" :style="{'background-image':`url(${newsList[1].image})`}"> -->
                <div class="rec_top" @click="seeNews(1)" v-if="newsList[1]">
                  <img class="square_img" :src="newsList[1].image" alt="">
                  <div class="mask"></div>
                  <div class="single_con">
                    <div class="single_title">{{newsList[1].title}}</div>
                    <div class="single_summary">{{newsList[1].summary}}</div>
                  </div>
                </div>
                <!-- <div class="res_bottom" @click="seeNews(2)" :style="{'background-image':`url(${newsList[2].image})`}"> -->
                <div class="res_bottom" @click="seeNews(2)" v-if="newsList[2]">
                  <img class="square_img" :src="newsList[2].image" alt="">
                  <div class="mask"></div>
                  <div class="single_con">
                    <div class="single_title">{{newsList[2].title}}</div>
                    <div class="single_summary">{{newsList[2].summary}}</div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 第二种布局 -->
          <el-row v-if="!oddNumber">
            <el-col :span="15">
              <div class="rectangle">
                <!-- <div class="rec_top" @click="seeNews(0)" :style="{'background-image':`url(${newsList[0].image})`}"> -->
                <div class="rec_top" @click="seeNews(0)" v-if="newsList[0]">
                  <img class="square_img" :src="newsList[0].image" alt="">
                  <div class="mask"></div>
                  <div class="single_con">
                    <div class="single_title">{{newsList[0].title}}</div>
                    <div class="single_summary">{{newsList[0].summary}}</div>
                  </div>
                </div>
                <!-- <div class="res_bottom" @click="seeNews(1)" :style="{'background-image':`url(${newsList[1].image})`}"> -->
                <div class="res_bottom" @click="seeNews(1)" v-if="newsList[1]">
                  <img class="square_img" :src="newsList[1].image" alt="">
                  <div class="mask"></div>
                  <div class="single_con">
                    <div class="single_title">{{newsList[1].title}}</div>
                    <div class="single_summary">{{newsList[1].summary}}</div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="9">
              <!-- <div class="square" @click="seeNews(2)" :style="{'background-image':`url(${newsList[2].image})`}"> -->
              <div class="square" @click="seeNews(2)" v-if="newsList[2]">
                <img class="square_img" :src="newsList[2].image" alt="">
                <div class="mask"></div>
                <div class="single_con">
                  <div class="single_title">{{newsList[2].title}}</div>
                  <div class="single_summary">{{newsList[2].summary}}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <!-- 右侧按钮 -->
        <el-col :span="3">
          <div class="news_arrow">
            <i v-if="newsRightArrow" class="el-icon-arrow-right" @click="rightNews"></i>
          </div>
        </el-col>
      </el-row>
      <el-row class="more_row">
        <el-col :span="18" class="more_col">
          <i class="more" @click="jumpMore">+more</i>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
    import { queryCustomerListOverOne, queryNewsListOverOne } from '@/api/channel/ljsdy.js'
    import ChannelBanner from '../../../components/channel/channelBanner.vue'
    export default {
        components: {
          ChannelBanner
        },
        data() {
            return {
                startNum: 0, //从第几个开始查询
                pageSize: 4, //每页显示个数,不变
                customerList: [],
                customerTotal: 0,
                arrowVisibility: false,
                leftArrowVisibility: false,
                rightArrowVisibility: false,
                //新闻
                newsStartNum: 0,
                newsPageSize: 3,
                newsList: [],
                newsTotal: 0,
                newsleftArrow: false,
                newsRightArrow: false,
                oddNumber: true, //奇数时使用该布局
            }
        },
        created() {
            this.queryCustomerCase();
            this.queryNews();
        },
        methods: {
            //查询客户案例
            queryCustomerCase() {
                let pageSize = this.pageSize;
                let startNum = this.startNum;
                queryCustomerListOverOne(pageSize, startNum).then(res => {
                    this.customerList = res.data.list;
                    this.customerTotal = res.data.total;
                    // console.log(res.data.list);
                    if (this.customerTotal <= 4) {
                        this.arrowVisibility = false;
                    } else {
                        this.arrowVisibility = true;
                        if (this.startNum == 0) {
                            this.leftArrowVisibility = false;
                            this.rightArrowVisibility = true;
                        } else if (this.startNum + 4 == this.customerTotal) {
                            this.leftArrowVisibility = true;
                            this.rightArrowVisibility = false;
                        } else {
                            this.leftArrowVisibility = true;
                            this.rightArrowVisibility = true;
                        }
                    };
                    // console.log(this.customerList);
                    // console.log(this.customerTotal);
                })
            },
            //点击左箭头
            slipLeft() {
                this.startNum--;
                this.queryCustomerCase();
            },
            //点击右箭头
            slipRight() {
                this.startNum++;
                this.queryCustomerCase();
            },
            //查询新闻动态
            queryNews() {
                let pageSize = this.newsPageSize;
                let startNum = this.newsStartNum;
                queryNewsListOverOne(pageSize, startNum).then(res => {
                    this.newsList = res.data.list;
                    this.newsTotal = res.data.total;
                    // console.log(this.newsList);
                    if (this.newsTotal <= 3) {
                        this.newsleftArrow = false;
                        this.newsRightArrow = false;
                    } else {
                        if (this.newsStartNum == 0) {
                            this.newsleftArrow = false;
                            this.newsRightArrow = true;
                        } else if (this.newsStartNum + 3 == this.newsTotal) {
                            this.newsleftArrow = true;
                            this.newsRightArrow = false;
                        } else {
                            this.newsleftArrow = true;
                            this.newsRightArrow = true;
                        }
                    }
                })
            },
            // 左滑新闻
            leftNews() {
                this.newsStartNum--;
                if (this.newsStartNum % 2 == 0) {
                    this.oddNumber = true;
                } else {
                    this.oddNumber = false;
                }
                this.queryNews();
            },
            //右滑新闻
            rightNews() {
                this.newsStartNum++;
                if (this.newsStartNum % 2 == 0) {
                    this.oddNumber = true;
                } else {
                    this.oddNumber = false;
                }
                this.queryNews();
            },
            seeNews(i) {
                let index = this.startNum + i;
                this.$router.push({
                    path: '/ljsdy/newsDetails',
                    query: {
                        index
                    }
                });
            },
            //跳转到更多界面
            jumpMore() {
                this.$router.push('/ljsdy/news')
            }
        }
    }
</script>
<style lang="scss" scoped="scoped">
    .main {
      margin-top: 80px;
    }
    /* 介绍 */
    
    .intro {
        text-align: right;
    }
    
    .intro_picture {
        width: 394px;
        height: 497px;
        margin: 100px;
    }
    
    .intro_title {
        margin: 50px;
        text-align: left;
        font-size: 30px;
        color: #507DF1;
    }
    
    .intro_title div {
        text-align: center;
    }
    
    .intro_content {
        font-size: 16px;
        color: #5E5E5E;
        text-align: left;
        line-height: 40px;
    }
    /* 客户案例 */
    
    .customer_case {
        height: 700px;
        padding: 50px 0;
        background: url(../../../assets/channel/ljsdy/carousel.png) center;
        background-size: 100% 100%;
        text-align: center;
    }
    
    .case_title {
        font-size: 30px;
        color: #F2F2F2;
    }
    
    .case_con {
        display: flex;
        justify-content: center;
        padding-top: 50px;
    }
    
    .arrow {
        height: 480px;
        font-size: 40px;
        color: rgb(79, 79, 79);
        line-height: 480px;
    }
    
    .arrow i:hover {
        color: white;
        cursor: pointer;
    }

    .single_case {
        width: 74%;
        height: 440px;
        padding: 8%;
        background-color: #fff;
        text-align: left;
        border-radius: 3%;
    }
    
    .single_case img {
        width: 100px;
        height: 100px;
        margin: 20px 0;
    }
    
    .single_name {
        font-size: 18px;
        color: #333;
    }
    
    .case_singlecon {
        margin-top: 20px;
        font-size: 13px;
        color: #4C4C4C;
        line-height: 24px;
    }

    /* 新闻动态 */
    
    .news {
        height: 600px;
        padding: 50px 0;
        background-color: #fff;
        text-align: center;
    }
    
    .news_title {
        margin-bottom: 50px;
        font-size: 30px;
        color: #507DF1;
    }
    
    .news_con {
        display: flex;
        justify-content: center;
    }
    
    .news_arrow {
        height: 450px;
        font-size: 40px;
        color: rgb(79, 79, 79);
        line-height: 480px;
    }
    
    .news_arrow i:hover {
        color: #507DF1;
        cursor: pointer;
    }
    
    .square {
        display: flex;
        align-items: center;
        position: relative;
        height: 420px;
        /* margin-right: 20px; */
        margin: 0 10px;
        text-align: left;
    }
    
    .square:hover {
        cursor: pointer;
    }
    .square_img {
      position: absolute;
      z-index: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    
    .mask {
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
    }
    
    .single_con {
        position: absolute;
        z-index: 2;
        padding: 0 20px;
    }
    
    .single_title {
        font-size: 20px;
        color: #fff;
    }
    
    .single_summary {
        font-size: 12px;
        color: #fff;
        line-height: 30px;
    }
    
    .rectangle {
        height: 420px;
        margin: 0 10px;
        text-align: left;
    }
    
    .rec_top {
        display: flex;
        align-items: center;
        position: relative;
        height: 200px;
    }
    
    .rec_top {
        cursor: pointer;
    }
    
    .res_bottom {
        display: flex;
        align-items: center;
        position: relative;
        height: 200px;
        margin-top: 20px;
    }
    
    .res_bottom {
        cursor: pointer;
    }
    /* more */
    
    .more_row {
        display: flex;
        justify-content: center;
    }
    
    .more_col {
        text-align: right;
    }
    
    .more {
        font-size: 20px;
        color: #5783EE;
    }
    
    .more:hover {
        text-decoration: underline;
        cursor: pointer;
    }
</style>